import { Component, EventEmitter, Output, Input, OnInit } from '@angular/core';
import { Utils } from '../utils/utils';

@Component({
  selector: 'cm-custom-upload-multiple-button',
  templateUrl: './custom-upload-multiple-button.component.html',
  styleUrls: ['./custom-upload-multiple-button.component.scss'],

  host: { 'class': 'cm-custom-upload-multiple-button' }
})
export class CustomUploadMultipleButtonComponent implements OnInit {
  @Output()
  public filesChange: EventEmitter<File[]> = new EventEmitter();

  @Input()
  public label: string;

  @Input()
  public singleFileUpload: boolean;

  @Input()
  initialFilesList: File[];

  @Input()
  emitInitialFileChange: boolean;

  files: File[] = [];
  duplicateFileNames = [];

  public id = Utils.generateGuid();

  constructor() {
  }

  ngOnInit() {
    if (this.initialFilesList) {
      this.initialFilesList.forEach(item => {
        this.files.push(item);
      });

      if (this.emitInitialFileChange) {
        this.filesChange.emit(this.files);
      }
    }
  }

  onFilesChange(fileList: FileList) {
    if (fileList.length === 0) {
      return;
    }

    if (this.singleFileUpload) {
      this.files = [fileList[0]]; // take only first file from the list
    } else {
      const files = Object.keys(fileList);
      for (let i = 0; i < files.length; i++) {
        const file = <File>fileList[files[i]];
        this.tryToAddFileToList(file);
      }
    }
    this.filesChange.emit(this.files);
    this.clearDuplicateNamesMessages();
  }

  removeFile(file: File) {
    const findIndex = this.files.findIndex(item => file.name === item.name && file.size === item.size);
    if (findIndex !== -1) {
      this.files.splice(findIndex, 1);
      this.filesChange.emit(this.files);
    }
  }

  // list cannot contain 2 files with the same name
  tryToAddFileToList(file: File) {
    if (this.isFileNameUnique(file)) {
      this.files.push(file);
    } else {
      this.duplicateFileNames.push(file.name);
    }
  }

  isFileNameUnique(file): boolean {
    return !this.files.some(item => item.name === file.name);
  }

  clearDuplicateNamesMessages() {
    setTimeout(() => {
      this.duplicateFileNames = [];
    }, 3000);
  }

  reset(){
    this.files = [];
  }

}
